<template>
  <div class="container container-main footer-kids">
    <div class="footer-kids__row">
      <div class="footer-kids__logo">
        <figure>
          <img loading="lazy" src="/svg/logo.svg" alt="AfterSchoolVote" />
        </figure>
        <p class="text--xs text-primary">
          {{ $t("footer.copyright.brand", { year: new Date().getFullYear() }) }}
        </p>
      </div>

      <ul class="footer-kids__nav">
        <FooterNavItem v-for="link in navLinks" :key="link.title" :link="link" />
      </ul>

      <FooterSocialList class="footer-kids__social" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

import FooterSocialList from "./FooterSocialList.vue"
import FooterNavItem from "./FooterNavItem.vue"
import navList from "static/footer-nav.ts"

const navLinks = computed(() => navList.flatMap((chapter) => chapter.links))
</script>

<style lang="scss" scoped>
.footer-kids {
  padding: 54px 0;

  &__row {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: start;
    column-gap: 40px;
  }

  &__logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;

    img {
      height: 48px;
      width: auto;
      display: block;
    }
  }

  &__nav {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(4, max-content);
    justify-content: space-evenly;
    column-gap: 64px;
    row-gap: 16px;
  }

  &__social {
    justify-self: end;
  }
}

@media (max-width: 1023px) {
  .footer-kids {
    padding: 40px 0;

    &__row {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      column-gap: 24px;
    }

    &__logo {
      grid-column: 1;

      img {
        height: 48px;
      }
    }

    &__nav {
      grid-column: 2 / 4;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, auto);
      column-gap: 24px;
      justify-content: stretch;
    }

    &__social {
      grid-column: 4;
      justify-self: end;
    }
  }
}

@media (max-width: 620px) {
  .footer-kids {
    padding: 24px 0;

    &__row {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
    }

    &__logo {
      img {
        height: 48px;
      }
    }

    &__nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 12px;
    }

    &__social {
      justify-self: center;
    }
  }
}
</style>
